import { useState } from 'react';
import { FiEdit, FiPlus } from 'react-icons/fi';
import IntegrationModal from './IntegrationModal';
import ApiKeyManager from './ApiKeyManager';

export interface IntegrationInterface {
    id: string;
    service: string;
    description: string;
    status: boolean;
    addedOn: string;
}

const Integration = () => {
    const [integrations, setIntegrations] = useState<IntegrationInterface[]>([
        {
            id: Math.random().toString(36).substring(2, 6),
            service: 'Ticketing system',
            description: 'Manages admins, billing admins, support agents, developers, and...',
            status: true,
            addedOn: '13/05/2024'
        },
        {
            id: Math.random().toString(36).substring(2, 6),
            service: 'Payment gateway',
            description: 'Manages admins, billing admins, support agents, developers, and...',
            status: false,
            addedOn: '10/03/2024'
        }
    ]);

    const [formState, setFormState] = useState({
        integrationName: '',
        integrationDescription: '',
        integrationStatus: false,
        integrationAddedOn: '',
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editedIntegrationId, setEditedIntegrationId] = useState<string | null>(null);

    const [mode, setMode] = useState("add");

    const handleOpenModal = () => {
        setIsModalOpen(true);
        setMode("add");
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const [currentPage, setCurrentPage] = useState(1); // starts from 1
    const itemsPerPage = 4; // you can change this number

    const totalPages = Math.ceil(integrations.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentIntegrations = integrations.slice(startIndex, endIndex);
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleEditDiscount = (id: string) => {
        // Implement edit functionality
        console.log('Edit discount with ID:', id);
        setMode("edit");
        setIsModalOpen(true);
        setEditedIntegrationId(id);
    };

    return (
        <div className="mt-10">
            <div className="flex justify-between items-center mb-5">
                <h2 className="text-lg font-semibold text-white">Third party integrations</h2>
                <button
                    className="flex items-center gap-2 px-4 py-2 bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                    onClick={handleOpenModal}
                >
                    <FiPlus size={16} />
                    Add Integration
                </button>
            </div>

            <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                <table className="w-full">
                    <thead>
                        <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
                            <th className="text-left p-4 font-medium">Service</th>
                            <th className="text-left p-4 font-medium">Status</th>
                            <th className="text-left p-4 font-medium">Added on</th>
                            <th className="text-right p-4 font-medium">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentIntegrations.map((integration, index) => (
                            <tr key={index} className="border-b border-white/[0.08] hover:bg-[#3a3a3a33]">
                                <td className="p-4">
                                    <div>
                                        <div className="text-white">{integration.service}</div>
                                        <div className="text-gray-400 text-sm mt-1">{integration.description}</div>
                                    </div>
                                </td>
                                <td className="p-4">
                                    <div className={`inline-flex items-center px-2 py-1 rounded-full text-xs ${integration.status
                                        ? 'bg-[#1C3829] text-[#4ADE80]'
                                        : 'bg-[#7F1D1D] text-[#F87171]'
                                        }`}>
                                        {integration.status ? 'Active' : 'Inactive'}
                                    </div>
                                </td>
                                <td className="p-4 text-gray-400">{integration.addedOn}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <div className="flex justify-end gap-3">
                                        <button
                                            onClick={() => handleEditDiscount(integration.id)}
                                            className="text-blue-500 hover:text-blue-400"
                                        >
                                            <FiEdit size={18} />
                                        </button>
                                        {/* <button
                                            onClick={() => openDeleteModal(code.id)}
                                            className="text-red-500 hover:text-red-400"
                                        >
                                            <FiTrash2 size={18} />
                                        </button> */}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Pagination */}
            </div>
            <div className="flex items-center justify-between mt-4 text-sm text-gray-400">
                <div>
                    Showing {startIndex + 1}-{Math.min(endIndex, integrations.length)} from {integrations.length}
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="p-2 hover:text-white disabled:opacity-50"
                    >
                        ←
                    </button>
                    {pages.map(page => (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`w-8 h-8 rounded flex items-center justify-center ${currentPage === page
                                ? 'bg-[#3A3A3A] text-white'
                                : 'hover:text-white'
                                }`}
                        >
                            {page}
                        </button>
                    ))}
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="p-2 hover:text-white disabled:opacity-50"
                    >
                        →
                    </button>
                </div>

            </div>

            <div className="mt-10">
                <ApiKeyManager />
            </div>

            <IntegrationModal
                setEditedIntegrationId={setEditedIntegrationId}
                setMode={setMode} integrations={integrations} setIntegrations={setIntegrations} editedIntegrationId={editedIntegrationId} mode={mode} isOpen={isModalOpen} handleClose={handleCloseModal} formState={formState} setFormState={setFormState} />

        </div>
    );
};

export default Integration;
